<template>
    <AppMainFormCard :isLoading="isLoading" :tituloTela="tituloTela" :canDelete="isEditing" @delete="beforeDeleteRegistro" @add="novoRegistro" 
        :isSearch="true" @search="goSearch" >
        <v-form v-model="isFormValid" ref="form">
            <v-layout row justify-center>
                <v-flex class="item" xs12 md11 ma-5>
                    <h3><b>Dados da Tabela de Limite de Mortalidade</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row justify-center="">
                <v-flex class="item" xs11 md6 lg6>
                    <v-text-field :rules="[campoObrigatorio]" v-model.trim="registro.nmTabela" label="Nome da Tabela" outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs11 md5 lg5>
                    <v-autocomplete :rules="[campoSelectObrigatorio]" v-model="registro.sgTipoUep" :items="tiposUnidadesExploracao"
                        color="primary" item-text="dsTipoUnidadeExploracao" item-value="csTipoUnidadeExploracao" label="Tipo"
                        no-data-text="Nenhum registro" outlined clearable>
                    </v-autocomplete>
                </v-flex>
            </v-layout>
        </v-form>
        <v-layout row justify-center v-if="registro.idTabelaMetaMortalidade > 0">
            <v-flex sm2 xs2 md1>
                <DialogCadastroPontoTabela @saved="savePontoTabelaSelected" @closeDialog="closeDialogPontoTabela" @openDialog="openDialogPontoTabela"
                    :rec="atualPontoTabela" :dialog="dialogPontoTabela" labelItem="Semana" labelValor="Mortalidade" @deleted="beforeDeleteItemTabela"/>
            </v-flex>
            <v-flex sm12 xs12 md10 mt-2>
                <h3 >
                    <b>Pontos da Tabela</b>
                </h3>
            </v-flex>
        </v-layout>
        <v-layout row wrap justify-center pa-3 pt-0 v-if="registro.idTabelaMetaMortalidade > 0">
            <v-flex class="item" sm11 xs11 md12 lg12>
                <v-data-table :headers="headers" @click:row="editPonto" no-results-text="Nenhum registro encontrado" :loading="isLoadingPontosTabela"
                    :items="registro.pontos" color="secondary" loading-text="Carregando registros...aguarde">
                </v-data-table>
            </v-flex>
        </v-layout>
        <v-layout justify-center pa-3 v-if="registro.idTabelaMetaMortalidade > 0">
            <v-flex sm11 xs11 md11 lg12>
                <OneLineGraph v-if="exibeGrafico" :values="seriesPontos" :valueName="'Limite Aceitável'" :xName="'Semana'" :yName="'Mortalidade (%)'" 
                    :finalizadorValor="' %'"/>
            </v-flex>
        </v-layout>
        <v-layout pa-2 pr-8 pl-8>
            <v-flex>
                <AppMainActionsButtonsForm @save="saveRegistro" @return="voltar" :canDelete="false"/>
            </v-flex>
        </v-layout>
    </AppMainFormCard>
</template>

<script>
import { campoObrigatorio, campoSelectObrigatorio } from '@/filters/rules'
import { TituloShouldNavigate,
        MensagemShouldNavigate,
        MensagemSuccessSave } from '@/resourceMessageFile.js'

import AppMainFormCard from '@/components/layout/AppMainFormCard.vue'
import AppMainActionsButtonsForm from '@/components/layout/AppMainActionsButtonsForm.vue'
import OneLineGraph from "@/components/general/OneLineGraph.vue"
import DialogCadastroPontoTabela from "@/components/dialogs/DialogCadastroPontoTabela.vue"

export default {
    name: 'TabelaLimiteMortalidade',
    components: {
        AppMainFormCard,
        AppMainActionsButtonsForm,
        OneLineGraph,
        DialogCadastroPontoTabela,
    },
    data() {
        return{
            isFormValid: false,
            isEditing: false,
            isModified: false,
            registro: {},
            registroBanco: {},
            isLoading: false,
            headers: [
                { text: "Semana", value: "nrDia" },
                { text: "Mortalidade", value: "mortalidade", sortable: false },
            ],
            isLoadingPontosTabela: false,
            dialogPontoTabela: false,
            atualPontoTabela: {},
            seriesPontos: {
                nrDias: [],
                valor: [],
            },
            exibeGrafico: false,
        }
    },
    computed: {
        tituloTela: {
            get() {
                if (this.isEditing)
                    return 'Tabela de Limite de Mortalidade: ' + this.registro.idTabelaMetaMortalidade

                return 'Inserindo nova Tabela de Limite de Mortalidade'
            }
        },
        tiposUnidadesExploracao () {
            return this.$store.state.tiposUnidadesExploracao
        },
        tiposGenero () {
            return this.$store.state.tiposGenero
        },
    },
    methods: {
        campoObrigatorio,
        campoSelectObrigatorio,
        savePontoTabelaSelected(record) {
            var context = this
            this.exibeGrafico = false
            var itemPoint = {
                idTabelaMetaMortalidadePontos: record.idTabelaPontos,
                cdTabelaMetaMortalidade: parseInt(this.$route.params.id),
                nrDia: record.nrDia,
                mortalidade: record.valor
            }
            if (itemPoint.idTabelaMetaMortalidadePontos != null)
            {
                context.$axios.put('tabela-meta-mortalidade-pontos/' + itemPoint.idTabelaMetaMortalidadePontos, itemPoint)
                    .then(() => {
                        context.getRegistro(context.$route.params.id)
                    })
            }
            else
            {
                context.$axios.post('tabela-meta-mortalidade-pontos/', itemPoint)
                    .then(() => {
                        context.getRegistro(context.$route.params.id)
                    })
            }
            context.atualPontoTabela = {}
        },
        closeDialogPontoTabela() {
            this.atualPontoTabela = {}
            this.dialogPontoTabela = false
        },
        openDialogPontoTabela() {
            this.dialogPontoTabela = true
        },
        editPonto(item) {
            this.dialogPontoTabela = true
            var itemPoint = {
                idTabelaPontos: item.idTabelaMetaMortalidadePontos,
                nrDia: item.nrDia,
                valor: item.mortalidade
            }
            this.atualPontoTabela = itemPoint
        },
        beforeDeleteItemTabela(item) {
            this.atualPontoTabela = item
            this.$root.$confirm('Deseja Excluir?', 'O registro será excluído permanentemente.', { color: 'red', width: 400 })
            .then(confirm => {
                if (confirm)
                    this.deleteItemTabela()
            })
        },
        deleteItemTabela() {
            var context = this
            this.exibeGrafico = false
            this.$axios.delete('tabela-meta-mortalidade-pontos/' + this.atualPontoTabela.idTabelaPontos)
                .then(() => {
                    context.getRegistro(context.$route.params.id)
                    context.closeDialogPontoTabela()
                })
        },
        changeViewState(status, value) {
            if (status == 'isInserting'){
                this.isLoading = true
                if (this.$refs.form != undefined) 
                {
                    this.$refs.form.reset()
                }
                this.carregarRegistrosLimpos()
                this.isLoading = false
                this.isEditing = false
                this.isModified = false
            } else if (status == 'isEditing'){
                this.isLoading = true
                this.getRegistro(value)
                this.isEditing = true
            } else if (status == 'isError'){
                this.$store.commit('setSnack', {type: 'error', msg : value})
                this.isLoading = false
            } else if (status == 'endLoading'){
                this.isLoading = false
                this.exibeGrafico = true
            } else if (status == 'isLoading'){
                this.isLoading = true
            }
        },
        initViewFromRoute(route) {
            if (route.params.id){
                this.changeViewState('isEditing', route.params.id)
            } else {
                this.changeViewState('isInserting', null)
            }
        },
        getRegistro (id) {
            var context = this
            this.exibeGrafico = false
            this.$axios.get('tabela-meta-mortalidade/' + id)
                .then((response) => {
                    var rec = response.data[0].data
                    this.registro = Object.assign({}, rec)
                    this.registroBanco = Object.assign({}, rec)

                    this.registro.pontos.sort( (a, b) => {
                        return a.nrDia - b.nrDia
                    })

                    this.registroBanco.pontos.sort( (a, b) => {
                        return a.nrDia - b.nrDia
                    })

                    context.seriesPontos.nrDias = []
                    context.seriesPontos.valor = []
                    
                    context.registro.pontos.forEach(i => {
                        context.seriesPontos.nrDias.push(i.nrDia)
                        context.seriesPontos.valor.push(i.mortalidade)
                    })

                    this.changeViewState('endLoading')
                })
                .catch((error) => {
                    this.changeViewState('isError', error)
                    this.$router.push({ path: '/tabelaLimiteMortalidade'})
                })
        },
        saveRegistro() {
            if (this.$refs.form.validate())
            {
                if (this.isEditing)
                {
                    this.updateRegistro()
                }
                else
                {
                    this.insertRegistro()
                }
            }
        },
        insertRegistro () {
            this.changeViewState('isLoading')
            this.$axios.post('tabela-meta-mortalidade/', this.registro)
            .then((response) => {
                this.$router.replace({ name: 'tabelaLimiteMortalidade', params: { id: response.data[0].data.idTabelaMetaMortalidade }})
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.changeViewState('endLoading')
                this.$store.dispatch('actLoadTabelasLimiteMortalidade')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        updateRegistro() {
            this.changeViewState('isLoading')
            this.$axios.put('tabela-meta-mortalidade/' + this.registro.idTabelaMetaMortalidade, this.registro)
            .then(() => {
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.initViewFromRoute(this.$route)
                this.$store.dispatch('actLoadTabelasLimiteMortalidade')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        beforeDeleteRegistro() {
            this.$root.$confirm('Deseja Excluir?', 'O registro será excluído permanentemente.', { color: 'red', width: 400 })
            .then(confirm => {
                if (confirm)
                    this.deleteRegistro()
            })
        },
        deleteRegistro() {
            this.changeViewState('isLoading')
            this.$axios.delete('tabela-meta-mortalidade/' + this.registro.idTabelaMetaMortalidade)
            .then(() => {
                this.$router.go(-1)
                this.changeViewState('endLoading')
                this.$store.dispatch('actLoadTabelasLimiteMortalidade')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        novoRegistro() {
            this.$router.push({ path: '/tabelaLimiteMortalidade' })
        },
        carregarRegistrosLimpos() {
            this.registro = {
                idTabelaMetaMortalidade: 0,
                nmTabela: '',
                sgTipoUep: '',
                pontos: [],
            }
            this.registroBanco = {
                idTabelaMetaMortalidade: 0,
                nmTabela: '',
                sgTipoUep: '',
                pontos: [],
            }
        },
        goSearch() {
            this.$router.push({ path: '/tabelaLimiteMortalidadeSearch' })
        },
        shouldNavigate(to, from, next) {
            if (JSON.stringify(this.registro) !== JSON.stringify(this.registroBanco) && !this.isLoading)
            {
                this.$root.$confirm(TituloShouldNavigate, MensagemShouldNavigate, { color: 'red', width: 400 })
                    .then(confirm => {
                        next(confirm)
                        return confirm
                    })
            }
            else
            {
                next()
                return true
            }
        },
        voltar() {
            this.$router.go(-1)
        }
    },
    watch: {
        '$route' (to) {
            this.initViewFromRoute(to)
        },
    },
    mounted() {
        this.initViewFromRoute(this.$route)
    },
    beforeRouteUpdate(to, from, next){
        this.shouldNavigate(to, from, next)
    },
    beforeRouteLeave (to, from, next) {
        this.shouldNavigate(to, from, next)
    }
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
    .marginTitle {
        margin: 15px;
    }
    .headerCard {
        color: white; 
        background: #04222D; 
        padding:10px;
    }
</style>
